import React from "react";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";


export default function CardAvancementDocument({
  statut,onOpenDocuments
}) {

  return (
    <>
      <div className="bg-white rounded-lg p-4 mb-2">
        <h5><b>Collecte de documents</b></h5>
        <div className="flex flex-row justify-between items-center">

        {statut === "à faire" && (
          <p className="text-sm font-regular leading-6 text-gray-500 flex items-center">
            <b>
              <XMarkIcon className="size-6 mr-1 inline-flex" />
              En cours de collecte
            </b>
          </p>
        )}

        {statut === "fait" && (
          
            <p className="text-sm font-semibold leading-6 text-green-500 mb-0">
              <CheckCircleIcon className="size-6 mr-1 inline-flex" />
              Documents ajoutés
            </p>

            
          
        )}
        <button
  type="button"
  className="btn-main w-fit"
  onClick={() => onOpenDocuments?.("document")}
>
  Voir les documents
</button>
            </div>
      </div>
    </>
  );
}